import React from 'react';
import './Banner.css';

const Banner = () => {
    return null;
};

export default Banner;
